/**
 * Single source of truth for reading the signed-in user's role.
 *
 * The role used to live in the Cognito `given_name` claim. `given_name` is the
 * standard OIDC claim for a person's first name, and every enterprise IdP
 * populates it — so the moment SSO federation is enabled, a federated login
 * would overwrite the role with the user's actual first name.
 *
 * Role therefore moves to `custom:custom_role`. Reads fall back to `given_name`
 * so this ships before the Cognito backfill rather than after it; once every
 * pool is backfilled, delete LEGACY_ROLE_CLAIM and the `||` below.
 *
 * Components read the role through hooks/useIdentity → utils/identity's
 * resolveUserRole, which applies the same claim order to the redux slice and
 * the raw session token. This module holds the claim names and the helpers for
 * a payload that has not reached redux yet.
 */
export const ROLE_CLAIM = 'custom:custom_role';
export const LEGACY_ROLE_CLAIM = 'given_name';

/** Role from a decoded Cognito ID-token payload. */
export const roleFromPayload = (payload) => payload?.[ROLE_CLAIM] || payload?.[LEGACY_ROLE_CLAIM];

/** Role from a raw signIn/signUp axios response, before it reaches Redux. */
export const roleFromAuthResponse = (response) =>
  roleFromPayload(response?.data?.payload?.data?.cognitoRes?.idToken?.payload);
